import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialFinanceApi = {
    getTrialFinanceByTrialId: (trialId: number): Observable<Dtos.GetTrialFinanceByTrialIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialFinanceByTrialId = new Dtos.GetTrialFinanceByTrialId();
        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.GetTrialFinanceByTrialIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialFinanceById: (id: number): Observable<Dtos.GetTrialFinanceByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialFinanceById = new Dtos.GetTrialFinanceById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialFinanceByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialFinance: (trialFinance: Dtos.TrialFinance): Observable<Dtos.SetTrialFinanceResponse> => {

        let request: Dtos.SetTrialFinance = new Dtos.SetTrialFinance();

        request.trialFinance = trialFinance;

        // send request
        const response: Promise<Dtos.SetTrialFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
    createTrialFinance: (trialId: number): Observable<Dtos.CreateTrialFinanceResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialFinance = new Dtos.CreateTrialFinance();

        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.CreateTrialFinanceResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialFinance: (trialFinance: Dtos.TrialFinance): Observable<Dtos.ValidateTrialFinanceResponse> => {

        let request: Dtos.ValidateTrialFinance = new Dtos.ValidateTrialFinance();

        request.trialFinance = trialFinance;

        // send request
        const response: Promise<Dtos.ValidateTrialFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
}